import {
  canAccessAbac,
  canAccessAbacAny,
  canViewPlatformDocumentsUi,
  canViewSdkDocumentsUi,
  getAbacValueAtPath,
  ROUTING_EDIT_ACCESS_PATHS,
  shouldEnforceAbacForUser,
} from "./abacAccess";


export const SMS_MESSAGE_VIEW_PATHS = [
  ["sms", "message", "quick_send", "view"],
  ["sms", "message", "bulk_campaign", "view"],
  ["sms", "message", "personalized", "view"],
  ["sms", "message", "auto_schedule", "view"],
  ["sms", "message", "messages", "view"],
];

export const PLATFORM_DOCUMENTS_ACCESS_PATHS = [
  ["platform_documents", "cpaas_documentation", "features_documents"],
];

export const PLATFORM_SDK_ACCESS_PATHS = [
  ["platform_documents", "cpaas_business_api"],
];

export const ABAC_ROUTE_RULES = [
  { match: /^\/dashboard/i, path: ["sms", "dashboard", "view"] },
  { match: /^\/message/i, paths: SMS_MESSAGE_VIEW_PATHS },
  { match: /^\/template/i, path: ["sms", "template", "view"] },

  { match: /^\/user\/limit/i, path: ["user", "limit"] },
  { match: /^\/user\/multi-access/i, path: ["user", "multi_access"] },
  { match: /^\/user\/abac/i, path: ["user", "multi_access", "view"] },
  { match: /^\/user/i, path: ["user", "profile", "view"] },
  { match: /^\/smsc\/error-code/i, path: ["sms", "smsc_providers", "error_code", "view"] },
  { match: /^\/smsc\/list/i, path: ["sms", "smsc_providers", "smsc", "view"] },
  { match: /^\/smsc\/flag/i, path: ["sms", "smsc_providers", "smsc", "flag_update"] },
  { match: /^\/smsc\/status/i, path: ["sms", "smsc_providers", "smsc", "status_update"] },
  { match: /^\/smsc\/looping/i, path: ["sms", "smsc_providers", "looping", "view"] },
  { match: /^\/smsc\/blocking/i, path: ["sms", "smsc_providers", "blocking", "view"] },
  { match: /^\/smsc\/schedule/i, path: ["sms", "smsc_providers", "schedule", "view"] },
  { match: /^\/smsc\/special-settings/i, path: ["sms", "smsc_providers", "special_setting", "view"] },
  { match: /^\/smsc\/group-data/i, path: ["sms", "smsc_providers", "group", "view"] },
  { match: /^\/smsc\/alert/i, path: ["sms", "smsc_providers", "alert", "view"] },
  { match: /^\/smsc\/limits/i, path: ["sms", "smsc_providers", "limits", "view"] },
  { match: /^\/smsc\/http/i, path: ["sms", "smsc_providers", "http_smsc", "view"] },
  { match: /^\/smsc\/hlr-flag/i, path: ["sms", "smsc_providers", "hlr", "flag_update"] },
  { match: /^\/smsc\/hlr-status/i, path: ["sms", "smsc_providers", "hlr", "status_update"] },
  { match: /^\/smsc\/hlr/i, path: ["sms", "smsc_providers", "hlr", "view"] },
  { match: /^\/sales/i, path: ["sales_team", "view"] },
  { match: /^\/company/i, path: ["company", "view"] },
  { match: /^\/vendor/i, path: ["vendor", "view"] },
  { match: /^\/address-book/i, path: ["address_book", "view"] },
  { match: /^\/profile/i, path: ["navbar", "profile"] },

  // Reports
  { match: /^\/reports\/campaign\/aborted/i, path: ["sms", "reports", "campaign", "aborted"] },
  { match: /^\/reports\/campaign\/campaign/i, path: ["sms", "reports", "campaign", "campaign"] },
  { match: /^\/reports\/campaign\/schedule/i, path: ["sms", "reports", "campaign", "schedule"] },
  { match: /^\/reports\/summary\/delivery/i, path: ["sms", "reports", "summary", "delivery"] },
  { match: /^\/reports\/summary\/batch/i, path: ["sms", "reports", "summary", "batch"] },
  { match: /^\/reports\/detailed\/advanced/i, path: ["sms", "reports", "detailed_analytics", "delivery_advance"] },
  { match: /^\/reports\/detailed\/content/i, path: ["sms", "reports", "detailed_analytics", "delivery_content"] },
  { match: /^\/reports\/detailed\/smsc/i, path: ["sms", "reports", "detailed_analytics", "delivery_smsc"] },
  { match: /^\/reports\/latency/i, path: ["sms", "reports", "delivery_latency"] },
  { match: /^\/reports\/consumption/i, path: ["sms", "reports", "consumption"] },
  { match: /^\/reports\/lookup/i, path: ["sms", "reports", "lookup"] },
  { match: /^\/reports\/aggregated/i, path: ["sms", "reports", "aggregator"] },
  { match: /^\/reports\/profit/i, path: ["sms", "reports", "profit"] },
  { match: /^\/reports\/performance\/user/i, path: ["sms", "reports", "performance", "user"] },
  { match: /^\/reports\/performance\/route/i, path: ["sms", "reports", "performance", "route"] },
  { match: /^\/reports\/blocked/i, path: ["sms", "reports", "blocked"] },
  { match: /^\/reports\/tps/i, path: ["sms", "reports", "tps"] },
  { match: /^\/reports\/vendor-summary/i, path: ["sms", "reports", "vendor_summary"] },
  { match: /^\/reports\/edr/i, path: ["sms", "reports", "edr"] },
  { match: /^\/reports\/coverage/i, path: ["sms", "reports", "coverage"] },

  // SMS utilities
  { match: /^\/utilities\/edit\/bulk/i, path: ["sms", "sms_utilities", "campaign_manager"] },
  { match: /^\/utilities\/edit\/schedule/i, path: ["sms", "sms_utilities", "schedule_manager"] },
  {
    match: /^\/utilities\/two-way-report/i,
    path: ["sms", "sms_utilities", "two_way", "report"],
  },
  { match: /^\/utilities\/two-way/i, path: ["sms", "sms_utilities", "two_way"] },
  { match: /^\/utilities\/subscription/i, path: ["sms", "sms_utilities", "subscription"] },
  {
    match: /^\/utilities\/converter/i,
    paths: [
      ["sms", "sms_utilities", "campaign_manager"],
      ["sms", "sms_utilities", "schedule_manager"],
      ["sms", "sms_utilities", "two_way"],
      ["sms", "sms_utilities", "subscription"],
    ],
  },
  { match: /^\/subscription/i, path: ["sms", "sms_utilities", "subscription"] },

  // Approvals
  {
    match: /^\/approvals\/bulk\/approved-reject/i,
    paths: [
      ["sms", "sms_utilities", "approvals", "bulk", "approve_reject"],
      ["sms", "sms_utilities", "approvals", "bulk", "log"],
    ],
  },
  {
    match: /^\/approvals\/bulk\/log/i,
    path: ["sms", "sms_utilities", "approvals", "bulk", "log"],
  },
  {
    match: /^\/approvals\/bulk/i,
    paths: [
      ["sms", "sms_utilities", "approvals", "bulk", "approve_reject"],
      ["sms", "sms_utilities", "approvals", "bulk", "log"],
    ],
  },
  {
    match: /^\/approvals\/sender\/approved-reject/i,
    paths: [
      ["sms", "sms_utilities", "approvals", "sender", "approve_reject"],
      ["sms", "sms_utilities", "approvals", "sender", "log"],
    ],
  },
  {
    match: /^\/approvals\/sender\/log/i,
    path: ["sms", "sms_utilities", "approvals", "sender", "log"],
  },
  {
    match: /^\/approvals\/sender/i,
    paths: [
      ["sms", "sms_utilities", "approvals", "sender", "approve_reject"],
      ["sms", "sms_utilities", "approvals", "sender", "log"],
    ],
  },

  // Routing (sender routing: superadmin/system/tenant).
  // Edit page: *View / *Update / export / delete — not apply/undo/previous alone.
  { match: /^\/routing\/sender\/add/i, path: ["sms", "routing", "sender", "add"] },
  { match: /^\/routing\/sender\/edit/i, path: ["sms", "routing", "sender", "edit"] },
  { match: /^\/routing\/edit/i, paths: ROUTING_EDIT_ACCESS_PATHS },
  { match: /^\/routing\/copy/i, path: ["sms", "routing", "copy"] },
  { match: /^\/routing\/add/i, path: ["sms", "routing", "add"] },
  { match: /^\/routing/i, path: ["sms", "routing"] },

  { match: /^\/firewall/i, path: ["sms", "firewall"] },
  { match: /^\/wallet/i, path: ["navbar", "wallet"] },
  { match: /^\/developer\/sdk/i, paths: PLATFORM_SDK_ACCESS_PATHS },
  { match: /^\/downloads/i, paths: PLATFORM_DOCUMENTS_ACCESS_PATHS },
];

/** First allowed landing route when dashboard (or the current page) is denied. */
export const ABAC_FALLBACK_ROUTES = [
  "/dashboard",
  "/message",
  "/template",
  "/address-book",
  "/utilities/edit/bulk",
  "/utilities/edit/schedule",
  "/utilities/two-way",
  "/utilities/converter",
  "/utilities/subscription",
  "/reports/campaign/campaign",
  "/reports/summary/delivery",
  "/approvals/bulk",
  "/user",
  "/user/error-code",
  "/routing/edit",
  "/company",
  "/vendor",
  "/firewall",
  "/sales",
  "/downloads",
  "/developer/sdk",
];

export function hasNoAllowedAbacPages(permissions, user, profile) {
  if (!shouldEnforceAbacForUser(user, profile) || permissions == null) {
    return false;
  }
  return findFirstAllowedAbacRoute(permissions, user, profile) == null;
}

export function findFirstAllowedAbacRoute(
  permissions,
  user,
  profile,
  { exclude = [] } = {}
) {
  if (!shouldEnforceAbacForUser(user, profile) || permissions == null) {
    return "/dashboard";
  }
  const skip = new Set(
    (Array.isArray(exclude) ? exclude : [exclude])
      .filter(Boolean)
      .map((path) => String(path).split("?")[0])
  );
  for (const route of ABAC_FALLBACK_ROUTES) {
    if (skip.has(route)) continue;
    if (isAbacRouteAllowed(route, permissions, user, profile)) return route;
  }
  return null;
}

/** Returns the list of ABAC paths guarding `pathname`, or null when ungated. */
export function resolveAbacPathsForLocation(pathname) {
  const path = String(pathname || "").split("?")[0];
  for (const rule of ABAC_ROUTE_RULES) {
    if (!rule.match.test(path)) continue;
    if (rule.paths) return rule.paths;
    if (rule.path) return [rule.path];
  }
  return null;
}

/**
 * Route-level ABAC check shared by ProtectedRoute and the dashboard fallback.
 * `pathname` must be the logical app path (see getInternalPathFromLocation).
 * `explicitPath` overrides the route-map lookup.
 */
export function isAbacRouteAllowed(
  pathname,
  permissions,
  user,
  profile,
  explicitPath
) {
  if (!shouldEnforceAbacForUser(user, profile) || permissions == null) {
    return true;
  }
  const logicalPath = String(pathname || "").split("?")[0];
  if (!explicitPath && /^\/developer\/sdk/i.test(logicalPath)) {
    return canViewSdkDocumentsUi(permissions, user, profile);
  }
  if (!explicitPath && /^\/downloads/i.test(logicalPath)) {
    return canViewPlatformDocumentsUi(permissions, user, profile);
  }
  const explicit = explicitPath
    ? [
        Array.isArray(explicitPath)
          ? explicitPath
          : String(explicitPath).split("."),
      ]
    : null;
  const mapped = explicit || resolveAbacPathsForLocation(pathname);
  if (!mapped?.length) return true;

  // Only evaluate paths that exist in the tree; missing keys fail-open in
  // canAccessAbac, which would wrongly keep a route open when one of several
  // alternatives is explicitly denied.
  const present = mapped.filter(
    (path) => getAbacValueAtPath(permissions, path) !== undefined
  );
  const toCheck = present.length ? present : mapped;
  return toCheck.length === 1
    ? canAccessAbac(permissions, toCheck[0], user, profile)
    : canAccessAbacAny(permissions, toCheck, user, profile);
}
